<template>
  <button
    class="c-mobile-nav-close t-heading-5 j-mobile-nav__close"
    type="button"
    tabindex="2"
    @click="emitClick"
  >
    <img
      src="../../assets/icons/nav-close.svg"
      alt="close"
    >
  </button>
</template>

<script>
export default {
  name: "NavCloseBtn",
  data(){
    return {

    }
  },
  mounted(){

  },
  methods: {
    emitClick(e){
      this.$emit("click", e);
    }
  }
}
</script>
<style lang="scss" scoped>
  .c-mobile-nav-close {
    @include buttonReset;
  }
</style>